import { api } from '../api'

export const helpdeskApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getHelpdeskCategories: builder.query({
      query: () => ({ url: '/helpdesk/lookups/categories', method: 'GET' }),
      providesTags: ['HelpDesk'],
    }),
    getHelpdeskPriorities: builder.query({
      query: () => ({ url: '/helpdesk/lookups/priorities', method: 'GET' }),
      providesTags: ['HelpDesk'],
    }),
    getHelpdeskStatuses: builder.query({
      query: () => ({ url: '/helpdesk/lookups/statuses', method: 'GET' }),
      providesTags: ['HelpDesk'],
    }),
    getMyHelpdeskTickets: builder.query({
      query: ({ page, page_size, query }) => ({
        url: `helpdesk/tickets/${page}/${page_size}${query ? `?${query}` : ''}`,
        method: 'GET',
      }),
      providesTags: ['HelpDesk'],
    }),
    getMyClosedHelpdeskTickets: builder.query({
      query: ({ page, page_size, query }) => ({
        url: `helpdesk/tickets/closed/${page}/${page_size}${query ? `?${query}` : ''}`,
        method: 'GET',
      }),
      providesTags: ['HelpDesk'],
    }),
    getMyHelpdeskTicket: builder.query({
      query: (ticketId) => ({
        url: '/helpdesk/tickets/by-id',
        method: 'GET',
        params: { ticket_id: ticketId },
      }),
      transformResponse: (response) => response.data,
      providesTags: (_result, _error, ticketId) => [{ type: 'HelpDesk', id: ticketId }],
    }),
    createHelpdeskTicket: builder.mutation({
      query: (body) => ({
        url: '/helpdesk/tickets',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['HelpDesk'],
    }),
    createHelpdeskTicketMessage: builder.mutation({
      query: ({ formData }) => ({
        url: '/helpdesk/tickets/messages',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: (_result, _error, { ticket_id }) => [{ type: 'HelpDesk', id: ticket_id }],
    }),
    getAllUserHelpdeskTickets: builder.query({
      query: () => ({
        url: '/helpdesk/tickets/get-my-all-tickets',
        method: 'GET',
      }),
      transformResponse: (response) => response.data,
      providesTags: ['HelpDesk'],
    }),
    getMyHelpdeskTicketStatusHistory: builder.query({
      query: (ticketId) => ({
        url: '/helpdesk/tickets/by-id/status-history',
        method: 'GET',
        params: { ticket_id: ticketId },
      }),
      transformResponse: (response) => response.data,
      providesTags: (_result, _error, ticketId) => [{ type: 'HelpDesk', id: `${ticketId}-history` }],
    }),
    getHelpdeskEmailSettings: builder.query({
      query: () => ({ url: '/helpdesk/email-settings', method: 'GET' }),
      transformResponse: (response) => response.data,
      providesTags: ['HelpDeskEmailSettings'],
    }),
    updateHelpdeskEmailSettings: builder.mutation({
      query: (body) => ({ url: '/helpdesk/email-settings', method: 'PATCH', body }),
      transformResponse: (response) => response.data,
      invalidatesTags: ['HelpDeskEmailSettings'],
    }),
  }),
})

export const {
  useGetHelpdeskCategoriesQuery,
  useGetHelpdeskPrioritiesQuery,
  useGetHelpdeskStatusesQuery,
  useGetMyHelpdeskTicketsQuery,
  useGetMyClosedHelpdeskTicketsQuery,
  useGetMyHelpdeskTicketQuery,
  useCreateHelpdeskTicketMutation,
  useCreateHelpdeskTicketMessageMutation,
  useGetAllUserHelpdeskTicketsQuery,
  useGetMyHelpdeskTicketStatusHistoryQuery,
  useGetHelpdeskEmailSettingsQuery,
  useUpdateHelpdeskEmailSettingsMutation,
} = helpdeskApi
